'use client';

import ActivatePageContent from './ActivatePageContent';

export default function ActivatePage() {
    return <ActivatePageContent />;
}
